"use client";
import { SkfUiContext as e } from "../../contexts/SkfUiContext.js";
import { useContext as o } from "react";
function i() {
  const t = o(e);
  if (!t)
    throw new Error("Skf UI Components must be used inside a <SkfUiProvider>.");
  return "rootElement" in t ? t.rootElement : document == null ? void 0 : document.getElementById(t.rootId);
}
export {
  i as useSkfUiContext
};
